import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@/lib/i18n";
import { supabase, initUniversalSessionBridge } from "@/lib/supabase";
import { CookieConsentRoot } from "@/components/cookie-consent/CookieConsentRoot";

/**
 * Initialize Universal Session Bridge BEFORE rendering the app
 * This ensures session is detected and set before React components mount
 * 
 * CRITICAL: This must complete before App.tsx renders to avoid "required refresh" issue
 */
async function initializeApp() {
  try {
    console.log('[main.tsx] Inicjalizacja Universal Session Bridge przed renderowaniem aplikacji...');
    
    // Initialize session bridge and wait for completion
    // This will detect session from cookies/localStorage and set it via setSession()
    await initUniversalSessionBridge(supabase);
    
    // CRITICAL: Mark bridge as initialized in sessionStorage
    // This allows App.tsx to check if bridge has completed, even if event listener wasn't set up yet
    sessionStorage.setItem('domio-bridge-initialized', 'true');
    
    // CRITICAL: Dispatch custom event to notify App.tsx that bridge initialization is complete
    // This prevents flicker of auth errors before bridge finishes its work
    window.dispatchEvent(new CustomEvent('domio-bridge-initialized'));
    
    console.log('[main.tsx] Universal Session Bridge zakończony, renderowanie aplikacji...');
  } catch (error) {
    console.error('[main.tsx] Błąd inicjalizacji Universal Session Bridge:', error);
    // Even on error, mark as initialized so app doesn't hang
    sessionStorage.setItem('domio-bridge-initialized', 'true');
    window.dispatchEvent(new CustomEvent('domio-bridge-initialized'));
    // Continue rendering even if bridge initialization fails
    // App.tsx will handle the case when no session is available
  }
  
  // Render app after bridge initialization completes
  const root = document.getElementById("root");
  if (root) {
    createRoot(root).render(
      <>
        <CookieConsentRoot appSource="cleaning" />
        <App />
      </>,
    );
  }
}

// Start initialization
initializeApp();
